// PRD-66 — shared by the material-page notice and the roster notice.

import { formatList } from "@lib/intl"

/** How many names a sentence spells out before "y N más". */
const NAMED_MAX = 2

/**
 * "Ana López y Diego Ruiz", "Ana López, Diego Ruiz y 2 más" — in the locale's own
 * list grammar. `total` is the exact count (the server caps the names it
 * sends, never the count), so the overflow is honest even past the cap.
 */
export function formatLateNames(
  names: string[],
  total: number,
  moreLabel: (count: number) => string,
): string {
  const shown = names.slice(0, NAMED_MAX)
  const rest = Math.max(total - shown.length, 0)
  return formatList(rest > 0 ? [...shown, moreLabel(rest)] : shown)
}
